import {
    Box, Button, Card, CardActionArea, CardMedia, Icon,
    Paper, Tooltip, Typography, useTheme,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    tableCellClasses, Autocomplete,
    CircularProgress,
    TextField, styled,
    Checkbox as MuiCheckBox,
    FormControl,
    Select,
    MenuItem,
    FormControlLabel,
    InputLabel,
    CardContent,
    CardActions,
    Collapse,
    IconButtonProps,
    IconButton,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { Enviroment } from "../../shered/enviroments";
import { EstatisticasService, IListaDadosJogadoresPowerRanking, IListaDadosMapaCalor, IListaDadosPowerRankingFranquia } from "../../shered/services/api/estatisticas/EstatisticasService";
import { DataGrid, GridColDef, GridExpandMoreIcon, GridToolbar } from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";
import { ptBR } from '@mui/x-data-grid/locales';

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

export const ListagemDeMapaCalor: React.FC = () => {
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const { themeName } = useAppThemeContext();
    const theme = useTheme();
    const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [semImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [searchParams, SetSearchParams] = useSearchParams();
    const [dadosMapaCalor, setDadosMapaCalor] = useState<IListaDadosMapaCalor[]>([]);
    const [columnsRodadas, setColumnsRodadas] = useState<GridColDef[]>([]);
    const [totalCountJogadoresRanking, setTotalCountJogadoresRanking] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [existeDados, setExisteDados] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [filtroMelhores, setFiltroMelhores] = useState(1);
    const [codigoTemporadaFiltro, setcodigoTemporadaFiltro] = useState(0);
    const [codigoFranquiaFiltro, setCodigoFranquiaFiltro] = useState(0);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const [errors, setErrors] = useState({
        error: false,
        nomeFranquiaRef: "",
        showImagemFranquia: ""
    });

    useEffect(() => {
        setIsLoading(true);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            const fetchData = async () => {
                LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        const liga = result.dado;
                        setDadosLiga(liga);
                        if (liga.caminho_Logo !== null) {
                            setShowImagemFranquia(liga.caminho_Logo);
                        }
                        CarregarDadosMapaCalor(liga.codigo_Temporada);
                        setcodigoTemporadaFiltro(liga.codigo_Temporada);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }

                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    });

                await UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                    .then((result) => {
                        setIsLoading(false);
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.statusHTTP === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });
            }
            fetchData();
        }
    }, []);

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const CarregarDadosMapaCalor = async (codigoTemporada: number) => {
        setRemoveLoading(false);
        setIsLoading(true);
        setDadosMapaCalor([]);
        setColumnsRodadas([]);
        EstatisticasService.getDadosMapaCalor(Number(codigoLiga), codigoTemporada)
            .then(result => {
                setDadosMapaCalor(result.dado);
                const lstRodada = result.dado[0].informacoes_Rodada.sort(((a, b) => a.rodada > b.rodada ? 1 : -1));
                const dados = result.dado;
                setExisteDados(lstRodada.length > 0);

                const colunasIniciais: GridColDef[] = [                   
                     {
                        field: `nome`,
                        headerName: `FRANQUIA`,
                        width: UtilidadeService.isMobile() ? 110 : 140,
                        headerAlign: "center",
                        editable: false,
                        hideable: false,
                        disableColumnMenu: true,
                        sortable: UtilidadeService.isMobile() ? false : true,
                        headerClassName: 'super-app-theme--header',
                        renderCell: (params) => {
                            return (
                                <Box
                                    sx={{
                                        whiteSpace: 'pre-wrap',
                                    }}
                                >
                                    {params.value}
                                </Box>
                            );
                        },
                    }, {
                        field: `logo`,
                        headerName: `LOGO`,
                        width: 60,
                        editable: false,
                        sortable: false,
                        filterable:false,
                        align: "center",
                        disableColumnMenu: true,
                        headerAlign: "center",
                        headerClassName: 'super-app-theme--header',
                        renderCell: (params) => <img src={params.value !== null ? params.value : semImagemFranquia} width={45} height={50} />,

                    },
                ];

                for (let index = 0; index < lstRodada.length; index++) {
                    const aux: GridColDef = {
                        field: `${lstRodada[index].rodada}`,
                        headerName: `${lstRodada[index].rodada}`,
                        headerClassName: 'super-app-theme--header',
                        align: "center",
                        headerAlign: "center",
                        width: 37,
                        minWidth: 37,
                        sortable: false,
                         editable:false,
                        filterable:false,                        
                        disableColumnMenu: true,
                        renderCell: (params) => {
                            return (
                                dados.find(f => f.codigo === params.row.codigo)?.derrota[index] === true ? <Tooltip title={`${lstRodada[index].rodada} - ${params.row.nome}`}><span style={{ color: "red", fontWeight: "bold", fontSize: "14px" }}> D </span></Tooltip> :
                                    dados.find(f => f.codigo === params.row.codigo)?.vitoria[index] === true ? <Tooltip title={`${lstRodada[index].rodada} - ${params.row.nome}`}><span style={{ color: "green", fontWeight: "bold", fontSize: "14px" }}> V </span></Tooltip> : <Tooltip title={`${lstRodada[index].rodada} - ${params.row.nome}`}><span style={{ color: "orange", fontWeight: "bold", fontSize: "14px" }}> E </span></Tooltip>
                            )
                        }
                    }
                    colunasIniciais.push(aux);

                    if (index === (lstRodada.length - 1)) {
                        const aux: GridColDef = {
                            field: `logo`,
                            headerName: `LOGO`,
                            width: 60,
                            editable: false,
                            sortable: false,
                            filterable:false,
                            disableColumnMenu: true,
                            align: "center",
                            headerAlign: "center",
                            headerClassName: 'super-app-theme--header',
                            renderCell: (params) => <img src={params.value !== null ? params.value : semImagemFranquia} width={45} height={50} />,
                        }
                        colunasIniciais.push(aux);
                    }
                };

                setColumnsRodadas(colunasIniciais);
                setRemoveLoading(true);
                setIsLoading(false);
            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response.data.statusHTTP === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão Expirada! 1",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response.data.mensagem !== undefined) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados dos jodadores! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });
    }

    return (
        <LayoutBaseDePagina
            titulo={`Sequência de Jogos  - ${dadosLiga?.nome}`}
            showLogoImg={showImagemFranquia}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })} />}>
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{xs:12, sm:12}} sx={{ width: "100%" }}>
                    <Grid container size={{xs:12, sm:12}} direction="column" padding={2} spacing={2} >
                        <Grid container size={{xs:12, sm:12}} spacing={1}>
                            <Grid  size={{xs:12, sm:12}} >
                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}> Sequência de Jogos </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{xs:12, sm:12}} display="flex" justifyContent="initial" spacing={2}>
                                <Grid  size={{xs:12, sm:3,md:3}} display="flex" justifyContent="center">
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Temporada</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={codigoTemporadaFiltro}
                                            label="Temporada"
                                            onChange={(e) => setcodigoTemporadaFiltro(Number(e.target.value))}                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }
                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid  size={{xs:6, sm:2, md:2}} display={"flex"} justifyContent={"end"} alignSelf={"center"}>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        disableElevation
                                        onClick={() => CarregarDadosMapaCalor(codigoTemporadaFiltro)}
                                        startIcon={<Icon>change_circle</Icon>}
                                    >
                                        Pesquisar
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid  size={{xs:12, sm:12}}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            <Grid  size={{xs:12, sm:12}}  >
                                <Grid  size={{xs:12, sm:12}} style={{ width: "100%" }}  >
                                    <hr />
                                    {existeDados ? (
                                        <Box sx={{
                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                                fontWeight: "bold"
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: themeName === "light" ? "black" : "auto",
                                            },
                                            '& .MuiDataGrid-columnHeaderTitle': {
                                                fontWeight: "bold"
                                            }
                                        }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                getRowId={(rows) => rows.codigo}
                                                rows={dadosMapaCalor}
                                                columns={columnsRodadas}                                              
                                                //columnVisibilityModel={{ codigo: false }}
                                                autoHeight
                                                slots={{
                                                    toolbar: GridToolbar,
                                                  }}
                                                  slotProps={{
                                                    toolbar: {
                                                        printOptions: { disableToolbarButton: true },
                                                        csvOptions: { disableToolbarButton: true },
                                                }}}
                                                disableRowSelectionOnClick                                               
                                                hideFooterPagination={true}                                              
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 10 : 12,
                                                    fontWeight: 600
                                                }}
                                            />
                                        </Box>
                                    ) :
                                        <Grid  size={{xs:12, sm:12}} >
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}> Não possui informações para a temporada informada! </Typography>
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    )
}


